export const translator = (type: any, objType: any) => {
  if (Object.prototype.hasOwnProperty.call(objType, type)) {
    return objType[type];
  } else {
    return "Type not specified";
  }
};
